import {Injectable, signal} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../app.config';
@Injectable()
export class FuseConfigService
{
    token;
    settings: any;
    defaultSettings: any;
    onSettingsChanged: BehaviorSubject<any>;
    public userName = new BehaviorSubject(null);
    public userId = new BehaviorSubject(null);
    public documentstion = new BehaviorSubject(null);
    public eCall = new BehaviorSubject(null);
    public whatsapp = new BehaviorSubject(null);
    public superAdmin = new BehaviorSubject(null);
    public user = new BehaviorSubject(null);
    public role = new BehaviorSubject(null);
    public logo = new BehaviorSubject(null);
    public impersonation = new BehaviorSubject(null);
    public privacy = new BehaviorSubject(null);
    public organizationName = new BehaviorSubject(null);
    public organizationType = new BehaviorSubject(null);
    public country = new BehaviorSubject(null);
    public city = new BehaviorSubject(null);
    public organizationId = new BehaviorSubject(null);
    public activeFilter = new BehaviorSubject(null);
    public projectSettings = new BehaviorSubject(null);
    public platforms = new BehaviorSubject(null);
    public selectedPlatform = new BehaviorSubject(null);
    public toolbarColor = new BehaviorSubject(null);
    public userEmail = new BehaviorSubject(null);
    public canRecommend = new BehaviorSubject(null);
    public allowCompetency = new BehaviorSubject(null);

    public userId_Sig = signal(null);
    public role_Sig = signal(null);
    public selectedPlatformId_Sig = signal(null);
    public organizationId_Sig = signal(null);
    public activeFilter_Sig = signal(false);


    /**
     * @param router
     * @param platform
     */
    constructor(
        private router: Router,
        private http: HttpClient,
        private api: AppConfig,
        public platform: Platform
    )
    {
        // Set the default settings
        this.defaultSettings = {
            layout          : {
                navigation      : 'left', // 'right', 'left', 'top', 'none'
                navigationFolded: false, // true, false
                toolbar         : 'below', // 'above', 'below', 'none'
                footer          : 'none', // 'above', 'below', 'none'
                mode            : 'fullwidth' // 'boxed', 'fullwidth'
            },
            colorClasses    : {
                toolbar: 'mat-fuse-dark-700-bg',
                navbar : 'mat-fuse-dark-700-bg',
                footer : 'mat-fuse-dark-900-bg'
            },
            customScrollbars: true,
            routerAnimation : 'fadeIn' // fadeIn, slideUp, slideDown, slideRight, slideLeft
        };

        /**
         * Disable Custom Scrollbars if Browser is Mobile
         */
        if ( this.platform.ANDROID || this.platform.IOS )
        {
            this.defaultSettings.customScrollbars = false;
        }

        // Set the settings from the default settings
        this.settings = Object.assign({}, this.defaultSettings);

        // Reload the default settings on every navigation start
        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.setSettings({layout: this.defaultSettings.layout});
                }
            }
        );

        // Create the behavior subject
        this.onSettingsChanged = new BehaviorSubject(this.settings);

      this.user.next('false');
    }

    /**
     * Sets settings
     * @param settings
     */
    setSettings(settings)
    {
        // Set the settings from the given object
        this.settings = Object.assign({}, this.settings, settings);

        // Trigger the event
        this.onSettingsChanged.next(this.settings);
    }

  resetPass(data) {
    // console.log(data);
    return this.http.post(this.api.baseUrl + '/user/resetPass', data, this.api.jsonHeaders);
  }
  changePass(data) {
    // console.log(data);
    return this.http.post(this.api.baseUrl + '/user/changePass', data, this.api.jsonHeaders);
  }

  setOrganizationName(organizationName) {
      this.organizationName.next(organizationName);
  }
  setOrganizationType(organizationType) {
      this.organizationType.next(organizationType);
  }

  setOrganizationId(organizationId) {
      this.organizationId.next(organizationId);
  }
  setCountry(country) {
      this.country.next(country);
  }
  setCity(city) {
      this.city.next(city);
  }

  setToken(token) {
      this.token = token;
  }

  setUserEmail(userEmail) {
      this.userEmail.next(userEmail);
  }

  setSuperAdmin(name) {
    this.superAdmin.next(name);
  }
  setUser(name) {
    this.user.next(name);
  }

  setImpersonation(data) {
    this.impersonation.next(data);
  }

  setUserId(id) {
    this.userId.next(id);
  }

  setCanRecommend(canRecommend) {
    this.canRecommend.next(canRecommend);
  }

  setAllowCompetency(allowCompetency) {
    this.allowCompetency.next(allowCompetency);
  }

  setUserName(name) {
    this.userName.next(name);
  }

  setRole(role) {
    this.role.next(role);
  }

  setECall(data) {
    this.eCall.next(data);
  }

  setWhatsApp(data) {
    this.whatsapp.next(data);
  }

  setLogo(logo) {
    this.logo.next(logo);
  }

  setDocumentation(date) {
      this.documentstion.next(date);
  }

  setPrivacy(privacy) {
    this.privacy.next(privacy);
  }

  setActiveFilter(data) {
      this.activeFilter.next(data);
  }

  setPlatforms(data) {
      this.platforms.next(data);
  }

  selectPlatform(platform) {
      this.selectedPlatform.next(platform);
  }

  // Settings service

  getProjectSettings() {
    return this.http.get(this.api.baseUrl + '/settings/allSettings', this.api.jsonTokenHeaders);
  }

  getProjectSettingsByPlatform(platformId) {
    return this.http.get(this.api.baseUrl + '/settings/settingByPlatformId?platformId=' + platformId);
  }

  saveProjectSettings(data) {
    return this.http.post(this.api.baseUrl + '/settings/saveSettings', data, this.api.jsonTokenHeaders);
  }

  setProjectSettings(data) {
      this.projectSettings.next(data);
  }
}
